/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Email_PlaceholderInputs */

const en_common_sign_email_placeholder = /** @type {(inputs: Common_Sign_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your email`)
};

const zh_common_sign_email_placeholder = /** @type {(inputs: Common_Sign_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入邮箱地址`)
};

/**
* | output |
* | --- |
* | "Enter your email" |
*
* @param {Common_Sign_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_email_placeholder = /** @type {((inputs?: Common_Sign_Email_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Email_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_email_placeholder(inputs)
	return zh_common_sign_email_placeholder(inputs)
});
export { common_sign_email_placeholder as "common.sign.email_placeholder" }